export default __webpack_public_path__ + "static/media/mysteryBetLogo.e0dcdfd0.png";